const initialState = {
  userdata: null,
  username: null,
  loading: false,
  valid: false,
  token: null,
  role: null,
  id: null,
  email: null,
  error: null
}

export default initialState
